// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yj4Q","tabsBox":"styles_tabsBox__3XVrg","createButton":"styles_createButton__oe8fn"};